export enum TourHomeItemType {
  Tour = 'TourDto[]',
}
